import { useState } from "react";

export default function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    (event) => {
      setValues({
        ...fields,
        [event.target.id || event.target.name]: event.target.value,
      });
    },
  ];
}
